/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LegalDocumentRequirementQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type LegalDocumentRequirementQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly legalDocumentRequirements: ReadonlyArray<{ readonly __typename?: 'LegalDocumentRequirement', readonly acceptedAt: CK.Timestamp | null, readonly documentType: GraphQL.LegalDocumentType, readonly requirement: GraphQL.LegalDocumentRequirementType }> } | null };


export const LegalDocumentRequirementDocument = gql`
    query LegalDocumentRequirement($accountId: AccountId!) {
  account(id: $accountId) {
    id
    legalDocumentRequirements {
      acceptedAt
      documentType
      requirement
    }
  }
}
    `;

/**
 * __useLegalDocumentRequirementQuery__
 *
 * To run a query within a React component, call `useLegalDocumentRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalDocumentRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalDocumentRequirementQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useLegalDocumentRequirementQuery(baseOptions: Apollo.QueryHookOptions<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables> & ({ variables: LegalDocumentRequirementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables>(LegalDocumentRequirementDocument, options);
      }
export function useLegalDocumentRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables>(LegalDocumentRequirementDocument, options);
        }
export function useLegalDocumentRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables>(LegalDocumentRequirementDocument, options);
        }
export type LegalDocumentRequirementQueryHookResult = ReturnType<typeof useLegalDocumentRequirementQuery>;
export type LegalDocumentRequirementLazyQueryHookResult = ReturnType<typeof useLegalDocumentRequirementLazyQuery>;
export type LegalDocumentRequirementSuspenseQueryHookResult = ReturnType<typeof useLegalDocumentRequirementSuspenseQuery>;
export type LegalDocumentRequirementQueryResult = Apollo.QueryResult<LegalDocumentRequirementQuery, LegalDocumentRequirementQueryVariables>;